import { Grid } from '@mui/material';
import { ButtonCancel } from 'components/buttons';
import { ButtonApplyFilter } from 'components/buttons/ButtonApplyFilter';
import { MprcInputStyles } from 'components/filter/MprcInputStyles';
import { AutoCompleteDataModel } from 'components/MprcAutoComplete';
import { MprcRequestSnackbarErrorReport } from 'components/MprcRequestErrorReport';
import { TagUsage } from 'generated/CoreApi_v1';
import React, { useRef, useState } from 'react';
import { TagAutoComplete } from 'views/foundation/tag/components/TagAutoComplete';
import { IAdvFilterPickerProps, IAdvFilterResult } from '../interfaces';

////////////////////////////////////////////////////////////////////////////////

export const TagPicker: React.FC<IAdvFilterPickerProps> = (props) => {

    const { filter, onApply, onCancel } = props;
    const [selected, setSelected] = useState<AutoCompleteDataModel[]>([]);
    const inputRef = useRef<HTMLInputElement>(undefined);

    const usage = filter.pickerParams as TagUsage;
    const multiSelect = filter.canRepeat ?? false;

    ////////////////////////////////////////////////////////////////////////////////

    ///
    const handleApply = () => {
        if (selected.length > 0) {
            var newFilter = selected.map(item => ({
                command: filter!.command,
                optionalGroup: filter?.optionGroup,
                text: `${filter?.displayName.replace("...", "")}: ${item.label}`,
                value: item.key,
                quickFilter: null,
                period: null,
                range: null,
                includeDescendants: null
            })) as IAdvFilterResult[];

            onApply(newFilter, filter);
        }
    };

    ////////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////////

    return (
        <Grid container alignItems="flex-end" spacing={2} width="100%">
            <Grid size="grow">
                <TagAutoComplete
                    label={null}
                    autoFocus
                    usage={usage}
                    placeholder={filter.placeholder}
                    multiSelect={multiSelect}
                    selectedItems={selected}
                    onChange={(items) => setSelected(items)}
                    onError={MprcRequestSnackbarErrorReport}
                    onApply={handleApply}
                    onCancel={onCancel}
                    sx={MprcInputStyles.filter}
                    inputRef={inputRef}
                />
            </Grid>
            <Grid>
                <ButtonApplyFilter
                    variant="text"
                    disabled={selected.length == 0}
                    onClick={handleApply}
                />
                <ButtonCancel
                    variant="text"
                    onClick={onCancel}
                />
            </Grid>
        </Grid>
    );
};
